import { useQuery } from "react-query";
import { AuthUtils } from "../utils/AuthUtils";
import { useUserSession } from "./useUserSession";

/**
 * Custom hook to fetch the claims of the current identity token. Resolves to undefined when the user is not signed-in.
 *
 * The query is keyed on `username` so the claims are re-fetched after sign-in/sign-out.
 */
export const useIdTokenClaims = () => {
  const { username } = useUserSession();

  return useQuery(["getIdTokenClaims", username], {
    // A failed session fetch is treated as "not signed-in" so it does not block the form.
    queryFn: () => AuthUtils.getIdTokenClaims().catch(() => undefined)
  });
};
